import { render, staticRenderFns } from "./CollapseInfo.vue?vue&type=template&id=3d7ee24c"
import script from "./CollapseInfo.vue?vue&type=script&lang=js"
export * from "./CollapseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports